import { render, staticRenderFns } from "./call.vue?vue&type=template&id=64438de2&scoped=true"
import script from "./call.vue?vue&type=script&lang=js"
export * from "./call.vue?vue&type=script&lang=js"
import style1 from "./call.vue?vue&type=style&index=1&id=64438de2&prod&scoped=true&lang=css"
import style2 from "./call.vue?vue&type=style&index=2&id=64438de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64438de2",
  null
  
)

export default component.exports